// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_8MUqpGnYY9XvneB8q4FLQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyContactUs/CompanyTooltip/CompanyTooltip.scss
// module id = 1573
// module chunks = 0